import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InterceptStrategy } from './InterceptStrategy';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EmptyInterceptStrategy implements InterceptStrategy {
	constructor() { }

	isRefreshToken = false;

	isIntercepted(req: HttpRequest<any>): boolean {
		return req.url.includes('sce-backend-web-page');
	}

	getHttpRequest(req: HttpRequest<any>): HttpRequest<any> {
		return req;
	}

	isPosibleTokenExpired(error: HttpErrorResponse): boolean {
		return false;
	}

	refreshToken(): Observable<Record<string, string>> {
		return of({});
	}
}
